import React, { useMemo, useState } from 'react';

const TypingInput = ({ type, value, onChange, fullText, className }) => {

    const [placeholder, setPlaceholder] = useState('');

    useMemo(() => {
        let index = 0;
        let typing = true;
        let delayAfterFinish = 2000; // milliseconds
        let delayAfterClear = 1000;
        let interval;

        const startTyping = () => {
            interval = setInterval(() => {
                if (typing) {
                    setPlaceholder(fullText.slice(0, index + 1));
                    index++;
                    if (index === fullText.length) {
                        typing = false;
                        clearInterval(interval);
                        setTimeout(() => {
                            startClearing();
                        }, delayAfterFinish);
                    }
                }
            }, 100); // typing speed
        };

        const startClearing = () => {
            interval = setInterval(() => {
                if (!typing) {
                    index--;
                    setPlaceholder(fullText.slice(0, index));
                    if (index === 0) {
                        typing = true;
                        clearInterval(interval);
                        setTimeout(() => {
                            startTyping();
                        }, delayAfterClear);
                    }
                }
            }, 50); // clearing speed
        };

        startTyping();

        return () => clearInterval(interval); // Cleanup

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <input
            type={type || "text"}
            value={value}
            onChange={e => onChange(e.target.value)}
            placeholder={placeholder}
            className={className}
        />
    );
};

export default TypingInput;
